import { api } from './client.js'
import { errorMessage } from './errors.js'
import { streamOperation } from './operations.js'
import { rowsToBoxes, boxesToRows } from './redactionBoxes.js'

export function makeRedactionPorts(fileId, artifact = 'pdf') {
  return {
    loadDocument: async () => {
      const { data } = await api.get(`/api/files/${fileId}/download`, { params: { artifact }, responseType: 'arraybuffer' })
      return { data }
    },
    loadBoxes: async () => {
      const { data: file } = await api.get(`/api/files/${fileId}`)
      const { data: rows } = await api.get(`/api/files/${fileId}/redactions`)
      return { boxes: rowsToBoxes(rows), version: file.updatedAt }
    },
    save: async (boxes, baseVersion) => {
      try {
        const { data } = await api.put(`/api/files/${fileId}/redactions`, { boxes: boxesToRows(boxes), baseVersion })
        return { done: { version: data.version, boxes: rowsToBoxes(data.boxes) } }
      } catch (e) {
        if (e.response?.status === 409 && e.response.data?.code === 'STALE_VERSION')
          return { stale: { currentVersion: e.response.data.currentVersion } }
        throw e
      }
    },
    watch: operationId => streamOperation(operationId),
    findOccurrences: async (input, baseVersion) => {
      let op
      try {
        ;({ data: op } = await api.post(`/api/files/${fileId}/redactions/occurrences`, { ...input, baseVersion }))
      } catch (e) {
        if (e.response?.status === 409 && e.response.data?.code === 'STALE_VERSION')
          return { stale: { currentVersion: e.response.data.currentVersion } }
        throw new Error(errorMessage(e))
      }
      const done = await streamOperation(op.operationId)
      if (done.status === 'ERROR' && done.result?.code === 'STALE_VERSION') return { stale: { currentVersion: done.result.currentVersion } }
      if (done.status !== 'DONE') throw new Error(done.result?.error || 'the run did not finish')
      return { done: done.result }
    },
    capabilities: { findOccurrences: true }
  }
}
